export default {
    name: 'ModalExpand',
    functional: true,
    props: {
        render: Function,
        cancel: {
            type: Function,
        }
    },
    render:(h, ctx) => {
        return ctx.props.render(h, {
            cancel: ctx.props.cancel
        });
    }
};